// extracted by mini-css-extract-plugin
export default {"NavMini":"NavMini_NavMini__EsgpN","NavVertical":"NavMini_NavVertical__qP48v"};